<!-- MAIN APP LAYOUT -->
<div class="flex h-screen bg-slate-100 font-sans text-slate-900 overflow-hidden relative animate-fade-in">

    <!-- MODERN EXPANDABLE SIDEBAR (FIXED) -->
    <nav [class.w-64]="isSidebarExpanded()" [class.w-20]="!isSidebarExpanded()"
        class="fixed left-0 top-0 bottom-0 bg-gradient-to-b from-indigo-100 to-slate-50 border-r border-slate-200 flex flex-col transition-all duration-300 ease-in-out shadow-xl z-50">

        <!-- Logo Area -->
        <div class="h-20 flex items-center justify-center border-b border-slate-100 mb-4 cursor-pointer hover:bg-slate-50 transition-colors"
            (click)="router.navigate(['/monitor'])">
            <div
                class="w-10 h-10 rounded-xl bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center text-white shadow-lg shadow-indigo-500/20">
                <lucide-icon [img]="icons.Layers" class="w-5 h-5 text-white"></lucide-icon>
            </div>
            <div *ngIf="isSidebarExpanded()"
                class="ml-3 font-bold text-slate-800 tracking-wide animate-fade-in whitespace-nowrap overflow-hidden">
                STOCK
            </div>
        </div>

        <!-- Menu Items -->
        <div class="flex-1 flex flex-col gap-1 px-3">

            <!-- GROUP: MRP (only shown when user has access to at least one MRP item) -->
            <ng-container *ngIf="authService.hasRole(['Admin', 'Operator', 'Viewer'])">
                <p *ngIf="isSidebarExpanded()"
                    class="text-[9px] font-bold text-slate-400 uppercase tracking-widest px-3 pt-4 pb-1">MRP</p>
                <hr *ngIf="!isSidebarExpanded()" class="border-slate-200 mx-2 my-3" />
            </ng-container>

            <!-- 1. MONITOR (Admin, Operator, Viewer) -->
            <a *ngIf="authService.hasRole(['Admin', 'Operator', 'Viewer'])" routerLink="/monitor"
                routerLinkActive="bg-indigo-50 text-indigo-600" [class.text-slate-500]="!isActive('/monitor')"
                class="flex items-center p-3 rounded-xl transition-all group relative overflow-hidden hover:bg-indigo-50 hover:text-indigo-600">
                <div class="shrink-0 flex items-center justify-center w-6">
                    <lucide-icon [img]="icons.Activity" class="w-[22px] h-[22px]"></lucide-icon>
                </div>
                <span *ngIf="isSidebarExpanded()"
                    class="ml-3 font-medium text-sm animate-fade-in whitespace-nowrap">Monitor</span>

                <div *ngIf="!isSidebarExpanded()"
                    class="absolute left-16 bg-slate-800 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-50 whitespace-nowrap shadow-xl">
                    Monitor
                </div>
            </a>

            <!-- 2. PERFIS (Attributes: Admin) -->
            <a *ngIf="authService.hasRole(['Admin'])" routerLink="/profiles"
                routerLinkActive="bg-indigo-50 text-indigo-600" [class.text-slate-500]="!isActive('/profiles')"
                class="flex items-center p-3 rounded-xl transition-all group relative overflow-hidden hover:bg-indigo-50 hover:text-indigo-600">
                <div class="shrink-0 flex items-center justify-center w-6">
                    <lucide-icon [img]="icons.Layers" class="w-[22px] h-[22px]"></lucide-icon>
                </div>
                <span *ngIf="isSidebarExpanded()"
                    class="ml-3 font-medium text-sm animate-fade-in whitespace-nowrap">Perfis</span>

                <div *ngIf="!isSidebarExpanded()"
                    class="absolute left-16 bg-slate-800 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-50 whitespace-nowrap shadow-xl">
                    Perfis
                </div>
            </a>

            <!-- 3. DEMANDAS (Admin, Operator, Viewer) -->
            <a *ngIf="authService.hasRole(['Admin', 'Operator', 'Viewer'])" routerLink="/demand-import"
                routerLinkActive="bg-indigo-50 text-indigo-600" [class.text-slate-500]="!isActive('/demand-import')"
                class="flex items-center p-3 rounded-xl transition-all group relative overflow-hidden hover:bg-indigo-50 hover:text-indigo-600">
                <div class="shrink-0 flex items-center justify-center w-6">
                    <lucide-icon [img]="icons.FileUp" class="w-[22px] h-[22px]"></lucide-icon>
                </div>
                <span *ngIf="isSidebarExpanded()"
                    class="ml-3 font-medium text-sm animate-fade-in whitespace-nowrap">Demandas</span>

                <div *ngIf="!isSidebarExpanded()"
                    class="absolute left-16 bg-slate-800 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-50 whitespace-nowrap shadow-xl">
                    Demandas
                </div>
            </a>

            <!-- GROUP: PRODUTOS -->
            <p *ngIf="isSidebarExpanded()"
                class="text-[9px] font-bold text-slate-400 uppercase tracking-widest px-3 pt-4 pb-1">Produtos</p>
            <hr *ngIf="!isSidebarExpanded()" class="border-slate-200 mx-2 my-3" />

            <!-- 4. REPLICADOR (Admin, Operator, Viewer, ProductSyncOperator, ProductSyncViewer) -->
            <a *ngIf="authService.hasRole(['Admin', 'Operator', 'Viewer', 'ProductSyncOperator', 'ProductSyncViewer'])"
                routerLink="/product-replicator" routerLinkActive="bg-indigo-50 text-indigo-600"
                [class.text-slate-500]="!isActive('/product-replicator')"
                class="flex items-center p-3 rounded-xl transition-all group relative overflow-hidden hover:bg-indigo-50 hover:text-indigo-600">
                <div class="shrink-0 flex items-center justify-center w-6">
                    <lucide-icon [img]="icons.Copy" class="w-[22px] h-[22px]"></lucide-icon>
                </div>
                <span *ngIf="isSidebarExpanded()"
                    class="ml-3 font-medium text-sm animate-fade-in whitespace-nowrap">Replicador</span>

                <div *ngIf="!isSidebarExpanded()"
                    class="absolute left-16 bg-slate-800 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-50 whitespace-nowrap shadow-xl">
                    Replicador
                </div>
            </a>

            <!-- GROUP: INDÚSTRIA -->
            <ng-container
                *ngIf="authService.hasRole(['Admin', 'AlloraIntegrationOperator', 'AlloraIntegrationViewer'])">
                <p *ngIf="isSidebarExpanded()"
                    class="text-[9px] font-bold text-slate-400 uppercase tracking-widest px-3 pt-4 pb-1">Indústria</p>
                <hr *ngIf="!isSidebarExpanded()" class="border-slate-200 mx-2 my-3" />
            </ng-container>

            <!-- 5. INTEGRAÇÃO ALLORA (Admin, Operator, Viewer, AlloraSyncOperator, AlloraSyncViewer) -->
            <a *ngIf="authService.hasRole(['Admin', 'Operator', 'Viewer', 'AlloraSyncOperator', 'AlloraSyncViewer'])"
                routerLink="/allora-integration" routerLinkActive="bg-indigo-50 text-indigo-600"
                [class.text-slate-500]="!isActive('/allora-integration')"
                class="flex items-center p-3 rounded-xl transition-all group relative overflow-hidden hover:bg-indigo-50 hover:text-indigo-600">
                <div class="shrink-0 flex items-center justify-center w-6">
                    <lucide-icon [img]="icons.Factory" class="w-[22px] h-[22px]"></lucide-icon>
                </div>
                <span *ngIf="isSidebarExpanded()"
                    class="ml-3 font-medium text-sm animate-fade-in whitespace-nowrap">Integração Allora</span>

                <div *ngIf="!isSidebarExpanded()"
                    class="absolute left-16 bg-slate-800 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-50 whitespace-nowrap shadow-xl">
                    Integração Allora
                </div>
            </a>
            <!-- SYSTEM MONITOR (KPIs) -->
            <div class="mt-auto mb-4 px-3 flex flex-col gap-3">

                <!-- CPU KPI -->
                <div class="transition-all duration-300" [class.bg-white]="isSidebarExpanded()"
                    [class.p-3]="isSidebarExpanded()" [class.rounded-xl]="isSidebarExpanded()"
                    [class.shadow-sm]="isSidebarExpanded()" [class.border]="isSidebarExpanded()"
                    [class.border-slate-200]="isSidebarExpanded()">

                    <!-- EXPANDED: Detailed View -->
                    <div *ngIf="isSidebarExpanded()">
                        <div class="flex items-center justify-between mb-2">
                            <div class="flex items-center gap-2">
                                <div
                                    class="w-8 h-8 rounded-lg bg-indigo-50 flex items-center justify-center text-indigo-600">
                                    <lucide-icon [img]="icons.Cpu" class="w-4 h-4"></lucide-icon>
                                </div>
                                <div>
                                    <p class="text-[10px] font-bold text-slate-500 uppercase tracking-wider">CPU</p>
                                    <p class="text-xs font-medium text-slate-400">Processamento</p>
                                </div>
                            </div>
                            <span class="text-xl font-black text-slate-800">{{ systemMonitorService.cpuUsage()
                                }}%</span>
                        </div>
                        <div class="h-2 w-full bg-slate-100 rounded-full overflow-hidden">
                            <div class="h-full bg-indigo-500 rounded-full transition-all duration-700 ease-out"
                                [style.width.%]="systemMonitorService.cpuUsage()"></div>
                        </div>
                    </div>

                    <!-- COLLAPSED: Donut Chart -->
                    <div *ngIf="!isSidebarExpanded()" class="flex flex-col items-center gap-1 group"
                        [title]="'CPU: ' + systemMonitorService.cpuUsage() + '%'">
                        <span class="text-[10px] font-bold text-slate-500">CPU</span>
                        <div class="relative">
                            <svg class="transform -rotate-90 w-10 h-10">
                                <circle cx="20" cy="20" r="16" stroke="currentColor" stroke-width="3" fill="transparent"
                                    class="text-slate-200" />
                                <circle cx="20" cy="20" r="16" stroke="currentColor" stroke-width="3" fill="transparent"
                                    class="text-indigo-500 transition-all duration-700 ease-out"
                                    [attr.stroke-dasharray]="100"
                                    [attr.stroke-dashoffset]="getDashOffset(systemMonitorService.cpuUsage(), 100)" />
                            </svg>
                            <div class="absolute inset-0 flex items-center justify-center">
                                <span class="text-[10px] font-bold text-slate-700">{{ systemMonitorService.cpuUsage()
                                    }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- MEMORY KPI -->
                <div class="transition-all duration-300" [class.bg-white]="isSidebarExpanded()"
                    [class.p-3]="isSidebarExpanded()" [class.rounded-xl]="isSidebarExpanded()"
                    [class.shadow-sm]="isSidebarExpanded()" [class.border]="isSidebarExpanded()"
                    [class.border-slate-200]="isSidebarExpanded()">

                    <!-- EXPANDED: Detailed View -->
                    <div *ngIf="isSidebarExpanded()">
                        <div class="flex items-center justify-between mb-2">
                            <div class="flex items-center gap-2">
                                <div
                                    class="w-8 h-8 rounded-lg bg-purple-50 flex items-center justify-center text-purple-600">
                                    <lucide-icon [img]="icons.MemoryStick" class="w-4 h-4"></lucide-icon>
                                </div>
                                <div>
                                    <p class="text-[10px] font-bold text-slate-500 uppercase tracking-wider">Memória</p>
                                    <p class="text-xs font-medium text-slate-400">Uso de RAM</p>
                                </div>
                            </div>
                            <span class="text-xl font-black text-slate-800">{{ systemMonitorService.memoryUsage()
                                }}%</span>
                        </div>
                        <div class="h-2 w-full bg-slate-100 rounded-full overflow-hidden">
                            <div class="h-full bg-purple-500 rounded-full transition-all duration-700 ease-out"
                                [style.width.%]="systemMonitorService.memoryUsage()"></div>
                        </div>
                    </div>

                    <!-- COLLAPSED: Donut Chart -->
                    <div *ngIf="!isSidebarExpanded()" class="flex flex-col items-center gap-1 group"
                        [title]="'Memória: ' + systemMonitorService.memoryUsage() + '%'">
                        <span class="text-[10px] font-bold text-slate-500">RAM</span>
                        <div class="relative">
                            <svg class="transform -rotate-90 w-10 h-10">
                                <circle cx="20" cy="20" r="16" stroke="currentColor" stroke-width="3" fill="transparent"
                                    class="text-slate-200" />
                                <circle cx="20" cy="20" r="16" stroke="currentColor" stroke-width="3" fill="transparent"
                                    class="text-purple-500 transition-all duration-700 ease-out"
                                    [attr.stroke-dasharray]="100"
                                    [attr.stroke-dashoffset]="getDashOffset(systemMonitorService.memoryUsage(), 100)" />
                            </svg>
                            <div class="absolute inset-0 flex items-center justify-center">
                                <span class="text-[10px] font-bold text-slate-700">{{ systemMonitorService.memoryUsage()
                                    }}</span>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <!-- 3. CONFIGURAÇÕES (Attributes: Admin) -->
            <a *ngIf="authService.hasRole(['Admin'])" routerLink="/settings"
                routerLinkActive="bg-indigo-50 text-indigo-600" [class.text-slate-500]="!isActive('/settings')"
                class="flex items-center p-3 rounded-xl transition-all group relative overflow-hidden hover:bg-indigo-50 hover:text-indigo-600">
                <div class="shrink-0 flex items-center justify-center w-6">
                    <lucide-icon [img]="icons.Settings" class="w-[22px] h-[22px]"></lucide-icon>
                </div>
                <span *ngIf="isSidebarExpanded()"
                    class="ml-3 font-medium text-sm animate-fade-in whitespace-nowrap">Configurações</span>

                <div *ngIf="!isSidebarExpanded()"
                    class="absolute left-16 bg-slate-800 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-50 whitespace-nowrap shadow-xl">
                    Configurações
                </div>
            </a>

        </div>

        <!-- Toggle Button -->
        <button (click)="toggleSidebar()"
            class="absolute -right-3 top-24 bg-indigo-600 text-white p-1 rounded-full shadow-lg hover:bg-indigo-500 transition-colors z-50 border-2 border-white flex items-center justify-center w-6 h-6">
            <!-- Dynamic Icon -->
            <lucide-icon [img]="isSidebarExpanded() ? icons.ChevronLeft : icons.ChevronRight"
                class="w-3.5 h-3.5"></lucide-icon>
        </button>

        <!-- Footer User -->
        <div class="p-4 border-t border-slate-200">
            <div class="flex items-center gap-3">
                <div
                    class="w-8 h-8 rounded-full bg-indigo-100 border border-indigo-200 flex items-center justify-center text-xs font-bold text-indigo-700 uppercase">
                    {{ (authService.currentUser()?.name | slice:0:2) || 'US' }}
                </div>
                <div *ngIf="isSidebarExpanded()" class="overflow-hidden animate-fade-in">
                    <p class="text-xs font-medium text-slate-800 truncate w-32"
                        [title]="authService.currentUser()?.name">{{ authService.currentUser()?.name }}</p>
                    <p class="text-[10px] text-slate-500 truncate w-32" [title]="authService.currentUser()?.email">{{
                        authService.currentUser()?.email }}</p>
                    <button (click)="logout()"
                        class="text-[10px] text-red-500 hover:text-red-700 transition-colors mt-0.5 font-semibold">SAIR
                        DO SISTEMA</button>
                </div>
            </div>
        </div>
    </nav>

    <!-- OVERLAY (WHEN SIDEBAR OPEN) -->
    <div *ngIf="isSidebarExpanded()" class="fixed inset-0 bg-slate-900/20 backdrop-blur-sm z-40 transition-opacity"
        (click)="toggleSidebar()"></div>

    <!-- CONTENT WRAPPER -->
    <div class="flex-1 flex flex-col h-full ml-20 transition-all duration-300 relative z-0">
        <router-outlet></router-outlet>
    </div>
</div>